import Mastodon from "./mastodon"
import Funkwhale from "./funkwhale"
import PeerTube from "./peertube"

import sortBy from "lodash/sortBy"

export default {
  all () {
    return sortBy(Object.values(this.sources), ["id"]).filter((s) => {
      return s.connect
    })
  },
  sources: {
    funkwhale: Funkwhale,
    mastodon: Mastodon,
    peertube: PeerTube,
    musicbrainz: {
      defaultAvatarIcon: "music_note",
      connect: false
    }
  }
}
